var map = {
	"./payment-method-bst.png": "b18e",
	"./payment-method-fpx.png": "afa4",
	"./payment-method-gpo.png": "decf",
	"./payment-method-ip8.png": "1301",
	"./payment-method-mpo.png": "f6e0",
	"./payment-method-shp.png": "706e",
	"./payment-method-tng.png": "6a31"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "47fa";